<template>
	<div>
		<h2 class="mb-3">{{$t('dashboardTitle')}}</h2>
		<AppLoader v-if="isLoading" class="text-center" small />
		<b-row class="dashboard-row" >
			<b-col cols="12">
				<b-row class="ml-4 mr-4 mt-3">
					<!-- <b-col cols="12">
						<b-alert
							show
						>Welcome to your ST Engineering Intermediary Onboarding Programme. In order to become an approved intermediary we require all our intermediaries to our due dilligence process both required by our compliance team as well as our regulatory obligations</b-alert>
					</b-col>-->
				</b-row>
				<b-row class="ml-2 mr-2 justify-content-md-center" >
					<!-- questionnaires cards -->
					<b-col cols="4" v-if="questionnaires.length > 0">
						<h3 class="text-muted">{{$t('questionnaires.title')}} ({{questionnaires.length}})</h3>

						<b-card
							@click="$router.push('/my-questionnaires')"
							bg-variant="default"
							class="mb-2 click-cursor card-wrapper"
							style="height:400px;"
						>
							<b-card-text class="my-5">
								<font-awesome-icon icon="file-signature" size="10x" style="color:#3DDC97;" />
							</b-card-text>
							<!-- <b-card-text>There are total of {{questionnaires.length}} due diligence questionnaires. We require you to complete all the forms in order to complete the onboarding process.</b-card-text> -->
							<b-card-text>
								<strong>{{$t('questionnaires.cardText')}}</strong>
							</b-card-text>
							<!-- <b-button class="ml-2" variant="outline-primary" to="/my-questionnaires">
								<font-awesome-icon icon="eye" />View
							</b-button> -->
						</b-card>
					</b-col>

					<!-- hide for ferrovial------------------- -->
					<b-col cols="4" v-if="training.length > 0">
						<h3 class="text-muted">{{$t('training.title')}} ({{training.length}})</h3>

						<b-card
							style="height:400px;"
							@click="$router.push('/my-training')"
							bg-variant="default"
							class="mb-2 click-cursor card-wrapper"
						>
							<b-card-text class="my-5">
								<font-awesome-icon icon="graduation-cap" size="10x" style="color:#3DDC97;" />
							</b-card-text>
							<b-card-text>
								<strong>{{$t('training.cardText')}}</strong>
							</b-card-text>
						</b-card>
					</b-col>
					
					<!-- exam cards -->
					<b-col cols="4" v-if="exams.length > 0">
						<h3 class="text-muted">{{$t('certifications.title')}} ({{exams.length}})</h3>

						<b-card
							style="height:400px;"
							@click="$router.push('/my-certifications')"
							bg-variant="default"
							class="mb-2 click-cursor card-wrapper"
						>
							<b-card-text class="my-5">
								<font-awesome-icon icon="certificate" size="10x" style="color:#3DDC97;" />
							</b-card-text>
							<b-card-text>
								<strong>{{$t('certifications.cardText')}}</strong>
							</b-card-text>
						</b-card>
					</b-col>

					
					<!-- certifications cards -->
					<b-col cols="4" v-if="certifications.length > 0">
						<h3 class="text-muted">{{$t('annual-certifications.title')}} ({{certifications.length}})</h3>

						<b-card
							style="height:400px;"
							@click="$router.push('/annual-certifications')"
							bg-variant="default"
							class="mb-2 click-cursor card-wrapper"
						>
							<b-card-text class="my-5">
								<font-awesome-icon icon="certificate" size="10x" style="color:#3DDC97;" />
							</b-card-text>
							<b-card-text>
								<strong>{{$t('annual-certifications.cardText')}}</strong>
							</b-card-text>
						</b-card>
					</b-col>

					<!-- training with tests-->
					<b-col cols="4" v-if="trainingWithTests.length > 0">
						<h3 class="text-muted">{{$t('trainingTest.title')}} ({{trainingWithTests.length}})</h3>

						<b-card
							style="height:400px;"
							@click="$router.push('/training-tests-list')"
							bg-variant="default"
							class="mb-2 click-cursor card-wrapper"
						>
							<b-card-text class="my-5">
								<font-awesome-icon icon="graduation-cap" size="10x" style="color:#3DDC97;" />
							</b-card-text>
							<b-card-text>
								<strong>{{$t('trainingTest.cardText')}}</strong>
							</b-card-text>
						</b-card>
					</b-col>
				</b-row>
			</b-col>
							<!-- <b-card-text>There are total of {{exams.length}} certification(s) required for you to complete and pass in order to be an approved intermediary</b-card-text> -->

			<!-- <b-col cols="3">
				<b-tabs content-class="mt-3">
					<b-tab title="General" active>
						<b-row class="mr-4">
							<b-card style="width:100%;" header-tag="header" footer-tag="footer" class="mb-3">
								<template v-slot:header>
									<h6 class="mb-0">CONTACT</h6>
								</template>

								<b-card-text class="text-left">
									<span>
										<strong>Compliancer officer</strong>
									</span>
									<br />Kevin Spiers
								</b-card-text>
								<b-card-text class="text-left">
									<span>
										<strong>Email</strong>
									</span>
									<br />Kevin Spiers
								</b-card-text>
								<b-card-text class="text-left">
									<span>
										<strong>Contact Number</strong>
									</span>
									<br />Kevin Spiers
								</b-card-text>
							</b-card>
							<b-card style="width:100%;" header-tag="header" footer-tag="footer" class="mb-3">
								<template v-slot:header>
									<h6 class="mb-0">STATUS</h6>
								</template>

								<b-card-text class="text-left">
									<span>
										<strong>Age</strong>
									</span>
									<br />2 months
								</b-card-text>
								<b-card-text class="text-left">
									<span>
										<strong>Questionnaire</strong>
									</span>
									<br />
									<b-progress height="5px" :value="10" variant="warning"></b-progress>
								</b-card-text>
								<b-card-text class="text-left">
									<span>
										<strong>Training</strong>
									</span>
									<br />
									<b-progress height="5px" :value="75" variant="success"></b-progress>
								</b-card-text>
								<b-card-text class="text-left">
									<span>
										<strong>Certifications</strong>
									</span>
									<br />
									<b-progress height="5px" :value="35" variant="danger"></b-progress>
								</b-card-text>
							</b-card>
						</b-row>
					</b-tab>
				</b-tabs>
			</b-col>-->
		</b-row>
	</div>
</template>

<script>
// import axios from "axios";
// import config from "./../configs/config";
import AppLoader from "../components/Loader/Loader";
// import AppLoaderModal from "../components/Loader/LoaderModal";
// import { Helper } from "../helpers";
import { mapGetters } from "vuex";
import moment from "moment";
import { HTTP } from "../utils/HTTP";
export default {
	name: "MyTPPPage",
	components: {
		AppLoader,
	},
	data() {
		return {
			accountUpdate: null,
			training: [],
			questionnaires: [],
			exams: [],
			trainingWithTests: [],
			certifications:[],
			summaries: [],
			totalRows: 0,
			filter: null,
			perPage: 10,
			currentPage: 1,
			sortBy: "created_at",
			sortDesc: true,
			pageOptions: [5, 10, 25, 50, 100],
			fields: [
				{
					key: "created_at",
					label: "Age"
				},
				{
					key: "type",
					label: "Type"
				},
				{
					key: "task_title",
					label: "Title"
				},
				// { key: "progress", label: "Progress" },
				// { key: "task_status", label: "Status" },
				{
					key: "actions",
					label: ""
				}
			]
		};
	},

	computed: {
		...mapGetters({
			form: "form1",
			selectedLanguage: "selectedLanguage",
			isLoading: "isLoading",
			userFormSubmitArray: "userFormSubmitArray"
		}),
		rows() {
			return this.totalRows;
		}
	},
	mounted() {
		this.checkUserAccountDetails();
		this.getTasks();
	},
	methods: {
		checkUserAccountDetails() {
			let userFullName = localStorage.getItem("userFullname");
			if (userFullName == "" || typeof userFullName == "undefined") {
				this.accountUpdate = false;
			} else {
				this.accountUpdate = true;
			}
		},

		age(value) {
			// // console.log(value);
			let localeData = moment.updateLocale("en", {
				relativeTime: {
					future: "in %s",
					past: "%s ago",
					s: "hello, a few seconds",
					ss: "%d seconds",
					m: "a minute",
					mm: "%d minutes",
					h: "an hour",
					hh: "%d hours",
					d: "a day",
					dd: "%d days",
					M: "a month",
					MM: "%d months",
					y: "a year",
					yy: "%d years"
				}
			});
			//return moment(value).fromNow();

			return moment(value).fromNow();
		},

		async getTasks() {
			let token = "Bearer " + localStorage.getItem("accessToken");
			let userId = localStorage.getItem("userId");
			try {
				let result = await HTTP(
					"post",
					"v1/mytpp/tasks",
					{
						userId: userId
					},

					{
						Authorization: token
					},
					null,
					true
				);
				this.training = result.data.training;
				this.questionnaires = result.data.questionnaires;
				this.exams = result.data.exams;
				this.certifications = result.data.certifications || [];
				this.trainingWithTests = result.data.trainingWithTests || [];
			} catch (error) {}
		}
	}
};
</script>


<style scoped>
.dashboard-row{
	height: calc(100vh - 130px);
	overflow-y: scroll;
}

</style>
